import { apiSlice } from "../api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAssignments: builder.query({
            query: () => ({
                url: "/assignments",
            }),
        }),
        getAssignmentByVideoId: builder.query({
            query: (videoId) => ({
                url: `assignments?video_id_like=${videoId}`,
            }),
        }),
        getAssignmentByStudentId: builder.query({
            query: (studentId) => ({
                url: `assignmentMark?student_id_like=${studentId}`,
            }),
        }),
        getAssignmentsMark: builder.query({
            query: () => ({
                url: "/assignmentMark",
            }),
        }),
        getAssignmentById: builder.query({
            query: (assignmentId) => ({
                url: `/assignments?id_like=${assignmentId}`,
            })
        }),
        addAssignment: builder.mutation({
            query: (data) => ({
                url: `/assignments`,
                method: 'POST',
                body: data
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                // pessimistically cash update
                try {
                    const assignment = await queryFulfilled;
                    dispatch(apiSlice.util.updateQueryData("getAssignments", undefined, (draftAssignments) => {
                        draftAssignments.push(assignment.data)
                    }));

                } catch (error) {

                }
            }
        }),
        submitAssignment: builder.mutation({
            query: (data) => ({
                url: `/assignmentMark`,
                method: 'POST',
                body: data
            }),
        }),
        updateAssignment: builder.mutation({
            query: (data) => ({
                url: `/assignments/${data.id}`,
                method: 'PATCH',
                body: data
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getAssignments", undefined, (draftAssignments) => {
                    const draftResult = draftAssignments.find(assignment => assignment.id == arg.id);

                    draftResult.title = arg.title;
                    draftResult.video_title = arg.video_title;
                    draftResult.totalMark = arg.totalMark;
                }));

                try {
                    await queryFulfilled;

                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
        updateAssignmentMark: builder.mutation({
            query: (data) => ({
                url: `/assignmentMark/${data.id}`,
                method: 'PATCH',
                body: data
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getAssignmentsMark", undefined, (draftAssignmentsMark) => {
                    const draftResult = draftAssignmentsMark.find(assignment => assignment.id == arg.id);

                    draftResult.mark = arg.mark;
                    draftResult.status = arg.published;
                }));

                try {
                    await queryFulfilled;

                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
        deleteAssignment: builder.mutation({
            query: (assignmentId) => ({
                url: `/assignments/${assignmentId}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getAssignments", undefined, (draftAssignments) => {
                    const index = draftAssignments.findIndex(assignment => assignment.id == arg);
                    draftAssignments.splice(index, 1)
                }));

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
    }),
});

export const { useGetAssignmentByVideoIdQuery, useGetAssignmentsMarkQuery, useGetAssignmentByStudentIdQuery, useGetAssignmentsQuery, useGetAssignmentByIdQuery, useAddAssignmentMutation, useSubmitAssignmentMutation, useUpdateAssignmentMutation, useUpdateAssignmentMarkMutation, useDeleteAssignmentMutation } = assignmentApi;
